// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1JXmK","title":"AfterBackImages_title__2-lM_","images":"AfterBackImages_images__3PCJM"};